let state = {
    "is_new": true,
    "user_state": 0, // 0 未关注，1已关注
    "name": "", //孩子姓名
    "headimg": "", // 头像
    "phone": "", //家长手机号 
    "phone_code": "",
    "province_id": "", //省份id，获取省份和城市见/wechat/api/city接口 
    "province_name": "",
    "city_id": "", //城市id
    "city_name": "",
    "area_code": "",
    "sex": "", //性别 1男 2女 
    "grade": "", //在读年级 
    "email": "", //邮箱 
    "uid": "", //培优账号（如有）
    "stu_num": "", // 学员编号
    "birth": "",//生日
    "py_area_code": "",//培优地区码
    "py_area_name": "",//配有地区名称
    "py_real_name": "",//培优真实姓名
    "py_grade": "",//培优年级
    "stu_id": "",
    "state": "", //是否关注公众号
    "is_complete": false, // 是否绑定信息
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/userInfo/state.js